import React from "react";
import "./GridCars.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CarModel from "../CarModel/CarModel";
import { isMobile } from "react-device-detect";

const gridCars = props => (
  <Grid item spacing={3} className={isMobile ? "GridCarMobile" : "GridCarWeb"}>
    <Grid item xs={12}>
      <div className={isMobile ? "TitleMobile" : "Title"}>
        Elegí tu próximo modelo, ¡0KM, cero vueltas!
      </div>
      <div className="Title-middle">
        Todos los modelos están disponibles, listos para ser patentados.
        ¡Reservá el tuyo ahora!
      </div>
    </Grid>
    <CarModel name="COROLLA" />
  </Grid>
);

export default gridCars;
